import { render, staticRenderFns } from "./CEditor.vue?vue&type=template&id=f875c8ca&scoped=true&"
import script from "./CEditor.vue?vue&type=script&lang=js&"
export * from "./CEditor.vue?vue&type=script&lang=js&"
import style0 from "./CEditor.vue?vue&type=style&index=0&id=f875c8ca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f875c8ca",
  null
  
)

export default component.exports